export const APPROVER_KPI_WIDGET_KEY = "kpi";

export const APPROVER_CHART_WIDGET_KEYS = ["status", "category", "bv", "valueSlab"];

export const APPROVER_DASHBOARD_WIDGET_KEYS = [
  APPROVER_KPI_WIDGET_KEY,
  ...APPROVER_CHART_WIDGET_KEYS,
];

export const createApproverWidgetLoadingState = (initial = false) =>
  Object.fromEntries(APPROVER_DASHBOARD_WIDGET_KEYS.map((k) => [k, initial]));
